import { Routes } from '@angular/router';

import { TaRoutes } from '@ta/menu';
import { AuthGuard } from '@ta/user';

export enum EFavoritesRoute {
  favorites = 'favorites',
}

TaRoutes.addRoute({
  key: EFavoritesRoute.favorites,
  url: 'favorites',
  children: [],
});

// Rattaché à l'utilisateur, pas au locataire : on parcourt le catalogue avant de créer son profil.
export const favoritesRoutes: Routes = [
  {
    path: '',
    title: 'app.pages.favorites.title',
    loadComponent: () =>
      import('./pages/favorites-list/favorites-list').then((c) => c.FavoritesListPage),
    canActivate: [AuthGuard],
  },
];
